import { createAction } from 'typesafe-actions';

import { SetErrorFallbackPageDataPayload, ClearErrorFallbackPageDataPayload } from './errorFallbackPage.types';

export const setErrorFallbackPageData = createAction('SET_ERROR_FALLBACK_PAGE_DATA')<SetErrorFallbackPageDataPayload>();

export const clearErrorFallbackPageData = createAction('CLEAR_ERROR_FALLBACK_PAGE_DATA')<ClearErrorFallbackPageDataPayload>();
